<div class="">
  <div class="tabs tabBlue videoTab">
    <div _ngcontent-c2="" class=" rightBtn">
      <span _ngcontent-c2=""><a class="uploadVideo" routerLink="../video-cms">Upload Video</a></span>
     
    </div> 
    <div class="tablinks bold leftBtn" onclick="opentab(event, 'page')" id="defaultOpen">Videos</div> 
   
  </div>
</div>
<div class="pageContainer tabcontent pageList" id="page" style="display:block;">
<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer">
  <div class="searchBlock">
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput id="searchAllElementsText" class="search-components textBox" type="text" placeholder="Search Pages here..."
          [(ngModel)]="str" (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true"
          (focusout)="searchFocus = false" autofocus />
      </div>
    </div>
    <div class="filterSection spImg">
      <i class="icon-filter"></i>
      <div class="fliterBlock">
        <ul class="filterOption">
          <ng-container *ngIf="filterList">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li *ngIf="enableSaranyu?filter.name:filter.name!=='Saranyu Status'" [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                  [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)" [facetkey]="filter.facet_key"></filter>
              </li>
              <span #moreButtonEl tabindex="0"
                [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                (click)="(showMore = !showMore)"
                *ngIf="(filterList && filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="closebg"></div>
  </div>


    <div class="headingsList">
      <ul>
        <ng-container *ngFor="let header of headerList">
          <li [class]="header.class" *ngIf="enableSaranyu?header.name:header.name!=='Saranyu Status'">{{header.name}}</li>
        </ng-container>
      </ul>
    </div>
    <div class="contentList">
      <ng-template #loading>
        <div style="text-align: center; display: inline-block; width: 100%;">
          <ng-container *ngIf="callFail">
            <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
              Sorry, Server Error
            </div>
          </ng-container>
          <ng-container *ngIf="!callFail">
            <div class="imagepreloader">
              <div class="a" style="--n: 5;">
                <div class="dot dot1" style="--i: 0;"></div>
                <div class="dot dot2" style="--i: 1;"></div>
                <div class="dot dot3" style="--i: 2;"></div>
                <div class="dot dot4" style="--i: 3;"></div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #nores>
        <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
      </ng-template>
      <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
      <ng-template #listData>
        <ng-container *ngIf="listArray && listArray.length > 0;else loading">
          <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">

            <div #dive [class]="(checkFocusInside(dive)) ? 'storyListing focused' : 'storyListing'">
              <div class='story_status'>
                <em #unlockDropdown [id]="item.id" [class]="getclassonCondition(item.lockedByUserId, item.cmsVideoStatus)"
                (click)="openOptions(i)">
                <div class="arrow_box single" *ngIf="(item.lockedByUserId)">
                  {{item.lockedByUserName}}</div>
                </em>
              </div>


              <ul [class.active]="!item.lockedByUserId" class="listingul"  #listData2>
                <a #listEl tabindex="0"
                  [routerLink]="'/dash/video-cms/' + item.id"
                  [queryParams]="{ 'domain': domain }">

                  <li class="name">
                    <small [title]="item.cmsVideoMetadata.videoTitle">
                      <div class="relhidden">
                        <div  class="listCell">{{item.cmsVideoMetadata.videoTitle}}</div>
                      </div>
                    </small>
                  </li>

                  <li class="statusS3YT">{{item?.s3LongVideoUploadStatus}}</li>

                  <li class="statusS3YT">{{item?.ytPrimaryUploadStatus}}</li>

                  <li class="statusS3YT" *ngIf="enableSaranyu">{{item.saranyuUploadStatus ? item.saranyuUploadStatus:'-'}}</li>


                  <!-- <ng-container *ngFor="let channel of channelList">
                    <li class="statusS3YT" *ngIf="channel.value === item?.cmsVideoMetadata?.primaryChannel">{{channel.key}}</li>
                  </ng-container> -->
                  <!-- <li class="statusS3YT"  *ngIf="channelList==null && item?.cmsVideoMetadata?.primaryChannel!==null">-</li> -->
                  <!-- <li class="statusS3YT" *ngIf="item?.cmsVideoMetadata?.primaryChannel===null">-</li> -->
                  
                  <li class="lastupdae">{{getNewTypeDate(item.createdDate)}}</li>

                  <li class="lastupdae">{{getNewTypeDate(item.lastModifiedDate)}}</li>

                  <li class="lastModifiedBy" [title]="item.lastModifiedByUserName">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.lastModifiedByUserName">{{item.lastModifiedByUserName | titlecase}}</div>
                    </div>
                  </li>
                </a>
                <span  class="viewEye">
                  <button [disabled]="(!item.primaryYoutubeVideo || !item.primaryYoutubeVideo.standardEmbedCode) &&
                  (!item.saranyuVideo || !item.saranyuVideo.embed_player)" class="icon-view-image viewbtn" (click)="openPreview(item)"></button>
                </span>
              <ng-container *ngIf="download$.has(item.id)">
                <ng-container *ngIf="download$.get(item.id) | async as downloading">
                  <span class="custommat_card">
                  <span *ngIf="downloading.progress == '100'" class="viewEye ">
                    <button [disabled]="!item.longVideoS3Url" class="icon-select reportbtn " (click)="downloadReport(item)"></button>
                  </span>
                  <mat-card>
                    <mat-progress-bar
                      [mode]="downloading.state == 'PENDING' ? 'buffer' : 'determinate'" 
                      [value]="downloading.progress">
                    </mat-progress-bar>
                  </mat-card>
                </span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!download$.has(item.id)">
                <span  class="viewEye">
                  <button [disabled]="!item.longVideoS3Url" class="icon-select reportbtn " (click)="downloadReport(item)"></button>
                </span>
              </ng-container>
                
                <!--div [class]="(togglePage === item.id) ? 'revertStoryBlock pagenavdrop active' : 'revertStoryBlock pagenavdrop'" id="page_{{item.id}}">
                  <ul>
                    <li><a href="/dash/page/nav-manager/{{item.id}}">Top Nav</a></li>

                    <li *ngIf="isSubNavEnabled"><a href="/dash/page/sub-nav-manager/{{item.id}}">Sub Nav</a></li>
                    <li><a href="/dash/page/{{item.id}}">Manage</a></li>
                  </ul>
                </div>
                <li class="relative pagemoredot" (click)="showNav(item.id)" *ngIf="item.pageType !== 'EXTERNAL'">
                  <span class="threedots"><span></span><span></span><span></span></span>
                </li-->

              </ul>
            </div>

          </ng-container>
        </ng-container>
      </ng-template>
    </div>
  





  <div class="footerPagination">
    <div class="pagination" *ngIf="totalRecords > 10">Page
      <ul>
        <ng-container *ngIf="7 > pages">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <!-- <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)"> -->
            <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            <!-- </ng-container> -->
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pages > 6">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
              <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            </ng-container>
          </ng-container>
          <li>..</li>
          <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngIf="totalRecords < 10;then displayPaging else showPaging"></ng-container>
    <ng-template #showPaging>
      <div class="recordList">Showing
        <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </div>
    </ng-template>
    <ng-template #displayPaging>
      <div class="recordList borderNone">
        Showing {{totalRecords}} results</div>
    </ng-template>
  </div>


</div>

<div class="lightBox readstory block" *ngIf="unlockPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Unlock Page</h3>
      <p>{{lockedUser}} will be able to view this page in read mode now.</p>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" name="cancel" (click)="cancelUnlock()" class="cancel gray mtb15 ml10">Cancel</button>
      <button type="button" name="unlock" (click)="unlockStory()" class="add blue mtb15 ml10 mr30">Unlock</button>
    </div>
  </div>
</div>
</div>

<ng-container  *ngIf="openPreviewItem">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
    </div>
    <div #embedEl class="lightContent serenyu"
    [ngClass]="{'compare lft': compareStory}">
      <div [innerHtml]="trustedHTML"  *ngIf="hasYoutubeVideo" class="video1">
      </div>
      <div class="video2"  *ngIf="hasSaranyuVideo" >
        <div [innerHtml]="saranyuHTML" ></div>
        <div *ngIf="hasSaranyuVideo" class="serunyu_form">
          <div class="serenyu_inner">
            <label style="color: white;">Saranyu Id :</label>
            <input type="text" class="textBox" class="form-control  ng-untouched ng-pristine ng-invalid"[(ngModel)]="saranyuId" readonly>
            <span class="pickStory icon-cards" (click)="copyFunction(saranyuId)" style="color: white;">
              <div id="pickUpList" class="arrow_box single" >Copy URL</div>
            </span>  
          </div>
          <div  class="serenyu_inner">
            <label style="color: white;">Saranyu Embed :</label>
            <input type="text" class="textBox" class="form-control  ng-untouched ng-pristine ng-invalid"[(ngModel)]="saranyuEmbed" readonly>
            <span class="pickStory icon-cards" (click)="copyFunction(saranyuEmbed)" style="color: white;">
              <div id="pickUpList" class="arrow_box single" >Copy URL</div>
            </span>  
          </div>
        </div>
      </div>
     
    </div>
  </div>
</ng-container>